"use client";

import { SafeHydrate } from "@/SafeHydrate";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { Users, BookOpen, Network, User, Calendar, FileText, Handshake, ChevronRight } from "lucide-react";
export default function ZonaPP() {
  const navigationItems = [{
    icon: <Users className="w-6 h-6" />,
    label: "Beranda Zona PP",
    href: "#"
  }, {
    icon: <BookOpen className="w-6 h-6" />,
    label: "Profil & Sejarah",
    href: "#"
  }, {
    icon: <Network className="w-6 h-6" />,
    label: "Struktur & Hierarki",
    href: "#"
  }, {
    icon: <User className="w-6 h-6" />,
    label: "Badan, Lembaga & Sayap",
    href: "#"
  }, {
    icon: <Users className="w-6 h-6" />,
    label: "Tokoh & Senior",
    href: "#"
  }, {
    icon: <SafeHydrate><Calendar className="w-6 h-6" /></SafeHydrate>,
    label: "Warta & Agenda",
    href: "#"
  }];
  const breadcrumbItems = [{
    label: "Beranda",
    href: "/"
  }, {
    label: "Zona PP",
    href: "/PPZonePage"
  }];
  const primaryCta = {
    text: "Pilih Wilayah Organisasi",
    href: "#",
    icon: <Users className="w-4 h-4" />,
    className: "zona-pp-button"
  };
  const secondaryCta = {
    text: "Login Zona PP",
    href: "#",
    icon: <User className="w-4 h-4" />,
    className: "zona-pp-button"
  };
  return <section id="zonapphero" className="bg-background">
      {}
      <div className="bg-gradient-to-r from-primary via-primary to-primary/95">
        {}
        <div className="bg-foreground text-background px-6 py-2 flex justify-between items-center text-sm">
          <span className="font-default">Pusat Informasi Resmi Organisasi Pemuda Pancasila</span>
          <div className="flex gap-4">
            <span>Kontak Kami</span>
            <div className="flex gap-3">
              <Link to="#" className="text-background hover:text-accent">
                <Users className="w-4 h-4" />
              </Link>
              <Link to="#" className="text-background hover:text-accent">
                <Handshake className="w-4 h-4" />
              </Link>
              <Link to="#" className="text-background hover:text-accent">
                <FileText className="w-4 h-4" />
              </Link>
            </div>
            <Link to="#" className="text-background hover:text-accent">
              Login
            </Link>
          </div>
        </div>

        {}
        <div className="px-6 py-4 flex justify-between items-center">
          {}
          <div className="flex items-center gap-4">
            <div className="bg-primary-foreground p-2 rounded-lg">
              <div className="w-12 h-12 bg-secondary rounded flex items-center justify-center">
                <span className="text-primary-foreground font-bold text-xs">PP</span>
              </div>
            </div>
            <div>
              <h1 className="text-primary-foreground font-bold text-lg font-default">
                ZONA PEMUDA PANCASILA
              </h1>
              <p className="text-primary-foreground/90 text-sm font-default">ABADI.NEWS</p>
            </div>
          </div>

          {}
          <div className="hidden lg:flex gap-8 items-center">
            {navigationItems.map((item, i) => <Link key={i} data-index={i} to={item.href} className="flex flex-col items-center gap-2 text-primary-foreground hover:text-accent transition-colors">
                {item.icon}
                <span className="text-xs font-default text-center max-w-[80px]">{item.label}</span>
              </Link>)}
          </div>

          {}
          <Button className="bg-secondary text-secondary-foreground hover:bg-secondary/90 flex items-center gap-2" size="sm">
            <FileText className="w-4 h-4" />
            Dashboard Zona PP
          </Button>
        </div>
      </div>

      {}
      <section className="zona-pp-hero relative min-h-[500px] flex items-center bg-cover bg-center bg-no-repeat bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/zona_pp_hero_image.png)]" aria-label="Zona PP Hero Section">
        <div className="absolute inset-0 bg-black/60" />
        
        <div className="container mx-auto px-6 relative z-10 py-20">
          {}
          <nav className="flex items-center gap-2 text-white/80 text-sm mb-8" aria-label="Breadcrumb">
            {breadcrumbItems.map((item, i) => <div key={i} className="flex items-center gap-2" data-index={i}>
                <Link to={item.href} className="hover:text-primary transition-colors">
                  {item.label}
                </Link>
                {i < breadcrumbItems.length - 1 && <ChevronRight className="w-4 h-4" />}
              </div>)}
          </nav>

          <div className="max-w-3xl">
            <h2 className="text-4xl md:text-6xl font-bold text-white mb-6 font-default leading-tight">
              ZONA PEMUDA PANCASILA
            </h2>
            <p className="text-lg md:text-xl text-white/90 mb-10 font-default max-w-2xl">
              Pusat informasi, struktur organisasi, warta, layanan dan database wilayah Pemuda Pancasila.
            </p>

            <div className="flex flex-wrap gap-4">
              <Button asChild className={`bg-primary text-primary-foreground hover:bg-primary/90 px-8 py-6 text-lg rounded-lg ${primaryCta.className}`}>
                <Link to={primaryCta.href} className="flex items-center gap-2">
                  {primaryCta.icon}
                  {primaryCta.text}
                </Link>
              </Button>
              
              <Button asChild variant="outline" className={`border-white text-white hover:bg-white hover:text-black px-8 py-6 text-lg rounded-lg ${secondaryCta.className}`}>
                <Link to={secondaryCta.href} className="flex items-center gap-2">
                  {secondaryCta.icon}
                  {secondaryCta.text}
                </Link>
              </Button>
            </div>
          </div>
        </div>
      </section>
    </section>;
}